import React from 'react';

import {
  DealNotFoundIcon
} from 'src/Components/Common';

import './NoDealsFound.css';

const goHome = () => {
  window.location.href = '/cloud/fibre/sales/leads';
};

const NoDealsFound = () => {

  return (
    <div className='deals-not-found-container'>

      <DealNotFoundIcon />
      <div className='deals-not-found-heading'>We currently don’t have any available plans for your area</div>
      <div className='deals-not-found-text'>Check out our LTE/5G deals for alternative connectivity options</div>
      <button className='deals-not-found-button'
        onClick={goHome}>
        Browse Home Internet deals
      </button>
    </div>
  );
};

export default NoDealsFound;